module.exports = __webpack_public_path__ + "img/5ac35e05-3e8d-4ddf-b49d-4d0ff2f7fd06.eb0b08e1.svg";